var _path, _rect, _rect2, _path2, _text, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _text2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdkOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1528,
    height: 496,
    viewBox: "0 0 1528 496",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.327 14.327 0 32 0H1496C1513.67 0 1528 14.327 1528 32V496H0V32Z",
    fill: "#A7D8C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 68,
    width: 812,
    height: 460,
    rx: 12,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 108,
    width: 68,
    height: 68,
    rx: 4,
    fill: "#E8FBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422 132L410 142L422 152M442 132L454 142L442 152",
    stroke: "#00A651",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 250,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fill: "#1F1F1F"
  }, "Your secret SDK token")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 300,
    width: 728,
    height: 34,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 356,
    width: 674,
    height: 84,
    rx: 16,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 382,
    width: 28,
    height: 28,
    rx: 4,
    stroke: "#00A651",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 482,
    width: 728,
    height: 40,
    rx: 8,
    fill: "#00A651"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 112,
    width: 502,
    height: 184,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#E2E2E2",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 140,
    width: 128,
    height: 32,
    fill: "#F0F0F0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 188,
    width: 252,
    height: 24,
    fill: "#F0F0F0"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 252,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fill: "#1F1F1F"
  }, "@cofee/checkout-web-sdk")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1306,
    cy: 236,
    r: 3.5,
    fill: "#1F1F1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1306,
    cy: 248,
    r: 3.5,
    fill: "#1F1F1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1306,
    cy: 260,
    r: 3.5,
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdkOverview);
export default __webpack_public_path__ + "static/media/sdk-overview.06e5603eb87d37600b10dea1b8297efb.svg";
export { ForwardRef as ReactComponent };